import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import UserRoles from "../../constants/UserRoles";
import {defaultState} from "../../constants/State";
import Cookies from "universal-cookie";
import APPCONFIG from "../../constants/Config";

class Users extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		super(props, model);
		model.filter = {'filterActive': null}
		this.state.filterActive = null;
		this.state.filter = {};
		this.limit = 20;
		this.handleFilter = this.handleFilter.bind(this);
	}

	handleFilter = async (event) => {
		event.persist()
		let active = (event.target.value === 'true');
		let all = event.target.id;
		if (active === true) {
			this.state.filterActive = true;
			this.state.noFilter = false;
		} else if (all === 'all') {
			this.state.filterActive = null;
			this.state.noFilter = true;
		} else {
			this.state.filterActive = false;
			this.state.noFilter = false;
		}
		await this.getUsers();
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		userModel.filter = {'filterActive': this.state.filterActive}
		this.setState({filter: {'filterActive': this.state.filterActive}})
		let items = await userModel.submit(null, 'GET_ALL');
		this.setState({data: items.items})
	}

	handleLoginAs = async (e) => {
		const pkey = parseInt(e.currentTarget.id);

		this.setState({loading: true});

		let dpModel = new API.BuildClass(Types.Admins._name, API.RequestType.READ);

		dpModel.object.pkey = pkey;

		try {
			let data = await dpModel.submit(null, API.RequestType.UPDATE, false, false, false, true);
			this.setState({loading: false});
			let cookies = new Cookies();
			if (cookies.get('auth_pkey')) {
				cookies.remove('auth_pkey');
				cookies.remove('hash');
			}
			let expiry = new Date();
			expiry.setDate(expiry.getDate() + 14)
			cookies.set('auth_pkey', data.pkey ? data.pkey : data.email, {path: '/', expires: expiry});
			cookies.set('hash', data.secure_auth, {path: '/', expires: expiry});
			// this.props.rootState.triggerAction('logout');
			this.props.history.push('/login');
			// window.location.reload();
		} catch (e) {
			// this.props.rootState.triggerAction('logout');
			// this.props.history.push('/login');
			// window.location.reload();
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [

			{
				Header: "Active",
				accessor: "active",
				width: 80,
				Cell: props => { return(<span className={'block color-info text-center'}>{props.original.active ? <PriorityHigh fontSize={'small'}/> : ''}</span>)},
				maxWidth: 65
			},
			{
				Header: "First Name",
				accessor: "name_first",
			},
			{
				Header: "Last Name",
				accessor: "name_last",
			},
			{
				Header: "Cell Phone",
				accessor: "phone_cell",
			},
			{
				Header: "Home Phone",
				accessor: "phone_home",
			},
			{
				Header: "Work Phone",
				accessor: "phone_work",
			}]

		if (this.props.rootState.roles.includes(UserRoles.Admin)) {
			columns.unshift({
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 60,
				Cell: props => {
					return (
						<span>
							<Button id={props.original.pkey} color="green-meadow" size={"sm"} block={true} onClick={this.handleLoginAs}>
								Login
							</Button>
						</span>
					);
				}
			})
		}

		if (APPCONFIG.settings.apiURL().includes('dev.') || APPCONFIG.settings.apiURL().includes('beta.')) {
			columns.push({
				Header: "Main Role",
				accessor: "main_role_name",
			})
		}

		columns.push({
			Header: "",
			className: "button-cell",
			filterable: false,
			sortable: false,
			width: 45,
			Cell: props => {
				return (
					<span>
						<Link to={"/users/" + props.original.pkey}>
							<Button color="green-meadow" size={"sm"} block={true}>
								<Edit fontSize={'small'}/></Button>
						</Link>
					</span>
				);
			}
		})

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Users')}
							<ButtonGroup size={"md"}>
								<Button
									value={true}
									onClick={this.handleFilter}
									outline={this.state.filterActive !== true}
									active={this.state.filterActive === true}
								>
									Active
								</Button>
								<Button
									value={false}
									onClick={this.handleFilter}
									outline={this.state.filterActive !== false}
									active={this.state.filterActive === false}
								>
									Inactive
								</Button>
								<Button
									id={'all'}
									onClick={this.handleFilter}
									outline={this.state.noFilter !== true}
									active={this.state.noFilter === true}
								>
									All
								</Button>
							</ButtonGroup>
							{this.renderHeaderRight("Users",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						getTdProps={(state, rowInfo, instance) => {
							return {
								style: {
									background: rowInfo?.original?.highlight === "1" ? 'red' : 'white'
								}
							}
						}}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						//getRowProps={row => ({className: row.original.active ? '' : 'inactive' })}
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
export default Framework.Components.withRootState(Users);